(() => {
  const start = Date.parse('2026-10-12T00:00:00-04:00');
  const end = Date.parse('2026-10-13T00:00:00-04:00');
  document.querySelectorAll('[data-kv-thanksgiving]').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const image = root.querySelector('img');
    const source = root.querySelector('source');
    const link = root.querySelector('a');
    const loadedAt = performance.now();
    const serverNow = Number(root.dataset.serverNow) * 1000;
    let timer;
    const update = () => {
      clearTimeout(timer);
      if (!root.isConnected) return;
      // Server time prevents a slow customer clock from extending the offer.
      const now = Math.max(Date.now(), serverNow + performance.now() - loadedAt);
      if (now >= end) {
        document.getElementById(root.dataset.styleId)?.remove();
        root.remove();
        window.dispatchEvent(new Event('resize'));
        return;
      }
      const phase = now >= start ? 'sale' : 'preview';
      if (root.dataset.phase !== phase) {
        source.srcset = root.dataset[phase + 'Mobile'];
        image.src = root.dataset[phase + 'Desktop'];
        image.alt = phase === 'sale'
          ? 'Our thanks. Your next adventure. 20% off today only, October 12. Use THANKSGIVING at checkout. Ends 11:59 p.m. Toronto time.'
          : 'Big thanks. Bigger smiles. 20% off October 12 only. Fill your cart today. Save on Thanksgiving. Use code THANKSGIVING on October 12.';
        link.setAttribute('aria-label', image.alt + ' Explore the Thanksgiving collection.');
        root.dataset.phase = phase;
      }
      timer = setTimeout(update, Math.min(60000, (now < start ? start : end) - now + 50));
    };
    update();
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
  });
})();
